import { Component, DestroyRef, Input, model, OnInit } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { MatInput } from '@angular/material/input';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { NgClass, NgIf } from '@angular/common';
import { NgxMaskDirective } from 'ngx-mask';
import { NoScrollDirective } from '../../../directives/nx-no-scroll.directive';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'mic-number-scroller',
  imports: [MatIcon, MatIconButton, MatInput, ReactiveFormsModule, TranslatePipe, NgIf, NgClass, NoScrollDirective],
  templateUrl: './number-scroller.component.html',
  styleUrl: './number-scroller.component.scss'
})
export class NumberScrollerComponent implements OnInit {
  protected valueCtrl: FormControl;
  protected notMultipleOfStep = '';
  protected isInputFocused = false;
  value = model(0);
  valid = model(true);
  @Input() step = 2;
  @Input() min = 0;
  @Input() max = 9999;

  constructor(private readonly destroyRef: DestroyRef) {}

  ngOnInit(): void {
    this.valueCtrl = new FormControl<number>(this.value());
    this.valueCtrl.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((value) => {
      if (value === null) return;
      if (value % this.step !== 0) {
        this.valid.update(() => false);
        this.notMultipleOfStep = 'common.number-scroller.notMultipleOfStep';
        return;
      } else if (value < this.min) {
        this.valueCtrl.setValue(this.min, { emitEvent: false });
      } else if (value > this.max) {
        this.valueCtrl.setValue(this.max, { emitEvent: false });
      }
      this.valid.update(() => true);
      this.value.update(() => this.valueCtrl.value);
      this.notMultipleOfStep = '';
    });
  }

  protected stepMinus() {
    this.valueCtrl.setValue(this.value() - this.step);
  }

  protected stepPlus() {
    this.valueCtrl.setValue(this.value() + this.step);
  }

  protected onFocus() {
    this.isInputFocused = true;
  }

  protected onBlur() {
    this.isInputFocused = false;
  }

  protected getBorderWarnClass(): string {
    return !this.valid() ? 'border-warn' : '';
  }

  protected getInputWarnClass(): string {
    return !this.valid() ? 'caret-warn color-warn' : '';
  }

  protected valueChange() {
    if (this.valueCtrl.value === null) {
      this.valueCtrl.setValue(this.min);
    }
  }
}
